import { Body } from '#/components/Text/Body';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import { VideoThumbnailPlayer } from '#/components/VideoThumbnailPlayer/VideoThumbnailPlayer';
import type { CmsApiVideoBlockData } from '#/modules/cms/api/types/blocks/CmsApiVideoBlock';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

type Props = {
  blockIndex: number;
  data: CmsApiVideoBlockData;
  fullWidthLayout?: boolean;
};

export function CmsVideoBlock({
  blockIndex,
  data: { headline, subtitle, videoUrl },
  fullWidthLayout,
}: Props) {
  return (
    <div>
      {(headline ?? subtitle) && (
        <div style={{ marginBottom: 48 }}>
          {headline && (
            <RichTextHeadline textAlignCenter={fullWidthLayout}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Video',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
              style={{ textAlign: fullWidthLayout ? 'center' : 'left' }}
            />
          )}
        </div>
      )}

      <div style={{ aspectRatio: '1280 / 720', lineHeight: 0 }}>
        <VideoThumbnailPlayer
          videoUrl={videoUrl}
          onClickPlay={() =>
            trackClicked('CMS Block', {
              block_position: blockIndex,
              block_type: 'Video',
            })
          }
          size={{ type: 'expand' }}
          eagerLoadThumbnail={blockIndex < 2}
          largePlayButton
          thumbnailQaId="cms-embed-video"
        />
      </div>
    </div>
  );
}
